import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import zhHans from './locales/zh-Hans.json';
import zhHant from './locales/zh-Hant.json';

const SUPPORTED_LANGS = ['en', 'zh-Hans', 'zh-Hant'];
const UI_LANGUAGE_STORAGE_KEY = 'gongju_ui_language';

function mapBrowserLanguageToSupported(lng) {
  const raw = String(lng || '').trim();
  if (!raw) return '';

  // Normalize common variants: zh_CN -> zh-CN
  const norm = raw.replace(/_/g, '-');
  const lower = norm.toLowerCase();

  if (lower === 'en' || lower.startsWith('en-')) return 'en';

  if (lower === 'zh' || lower.startsWith('zh-')) {
    // Prefer explicit script subtag if present.
    if (lower.includes('hant')) return 'zh-Hant';
    if (lower.includes('hans')) return 'zh-Hans';

    // Otherwise infer from region.
    const parts = lower.split('-');
    const region = parts[1] || '';
    if (['tw', 'hk', 'mo'].includes(region)) return 'zh-Hant';
    if (['cn', 'sg', 'my'].includes(region)) return 'zh-Hans';
    return 'zh-Hans';
  }

  // Let i18next fallback decide for other languages.
  return norm;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'zh-Hans': { translation: zhHans },
      'zh-Hant': { translation: zhHant },
    },
    supportedLngs: SUPPORTED_LANGS,
    fallbackLng: {
      'zh': ['zh-Hans'],
      'zh-CN': ['zh-Hans'],
      'zh-SG': ['zh-Hans'],
      'zh-MY': ['zh-Hans'],
      'zh-TW': ['zh-Hant'],
      'zh-HK': ['zh-Hant'],
      'zh-MO': ['zh-Hant'],
      default: ['en'],
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Priority: explicit UI override in localStorage > browser languages > fallback.
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: UI_LANGUAGE_STORAGE_KEY,
      caches: [], // Do not persist auto-detected language; only persist manual overrides.
      convertDetectedLanguage: mapBrowserLanguageToSupported,
    },
    react: {
      useSuspense: false,
    },
  });

// Keep <html lang="..."> in sync for accessibility/SEO.
i18n.on('languageChanged', (lng) => {
  try {
    document.documentElement.lang = String(lng || 'en');
  } catch (_) {
    // no-op
  }
});

export { SUPPORTED_LANGS, UI_LANGUAGE_STORAGE_KEY, mapBrowserLanguageToSupported };
export default i18n;

